var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportingManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 98.351,
    viewBox: "0 0 80 98.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "application",
    transform: "translate(-0.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M119.677,3.934A3.931,3.931,0,0,0,115.743,0H43.634A3.961,3.961,0,0,0,39.7,3.934V94.417a3.946,3.946,0,0,0,3.934,3.934h72.132a3.931,3.931,0,0,0,3.934-3.934l-.023-90.483ZM46.642,7.382h66.231v83.8H46.642Z",
    transform: "translate(-39.577)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(-1.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M158.34,99.2H135.605a3.934,3.934,0,1,0,0,7.868H158.34a3.934,3.934,0,1,0,0-7.868Z",
    transform: "translate(151.122 -81.747) rotate(90)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M158.34,189.8H142.771a3.934,3.934,0,1,0,0,7.868H158.34a3.934,3.934,0,1,0,0-7.868Z",
    transform: "translate(228.722 -81.781) rotate(90)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M158.34,189.8h-8.462a3.934,3.934,0,1,0,0,7.868h8.462a3.934,3.934,0,1,0,0-7.868Z",
    transform: "translate(254.722 -81.781) rotate(90)",
    fill: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M158.34,286.2H122.934a3.934,3.934,0,1,0,0,7.868H158.34a3.934,3.934,0,1,0,0-7.868Z",
    transform: "translate(312.122 -81.473) rotate(90)",
    fill: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M920.033,5308.09l11.07-7.489,15.263,18.322,13.561-7.646",
    transform: "translate(-899.41 -5280.21)",
    fill: "none",
    stroke: "#a8a8a8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingManagement);
export default __webpack_public_path__ + "static/media/reporting-management.2fa3b127a90fee08f967d18f54d42730.svg";
export { ForwardRef as ReactComponent };